import { type ButtonHTMLAttributes, forwardRef } from 'react';
import { cn } from '@/lib/utils';

interface IconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'ghost' | 'primary' | 'outline';
}

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  ({ className, variant = 'ghost', ...props }, ref) => {
    const baseStyles =
      'p-2 rounded-full font-medium transition-all flex items-center gap-2 cursor-pointer hover:opacity-60';

    const variantStyles = {
      ghost: 'hover:bg-surface-1',
      primary: `
        bg-primary
        text-primary-foreground
        hover:opacity-80
        shadow-sm
        hover:shadow-md
      `,
      outline: `
        bg-surface-1
        text-primary
        border
        border-base-300
        hover:bg-surface-2
      `,
    };

    return (
      <button ref={ref} className={cn(baseStyles, variantStyles[variant], className)} {...props} />
    );
  }
);

IconButton.displayName = 'IconButton';
